import "../../design/partnerCompanies.css";
import { useEffect, useRef, useState } from "react";
import api from "../../api/API_SERVERS"; // Adjust path to match your layout folder

export default function PartnerCompanies() {
    const trackRef = useRef(null);
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch Carousel Ads from Database
    useEffect(() => {
        const fetchCarouselAds = async () => {
            try {
                const res = await api.get("/api/public/ads");
                setCompanies(res.data.carousel || []);
            } catch (e) {
                console.error("Error loading partner companies:", e);
            } finally {
                setLoading(false);
            }
        };
        fetchCarouselAds();
    }, []);

    // RequestAnimationFrame Ticker Loop
    useEffect(() => {
        if (loading || companies.length === 0) return;

        const track = trackRef.current;
        let animation;
        let position = 0;

        const animate = () => {
            position -= 0.6; // Speed adjustments for pleasant movement
            // Reset position exactly when the first 1/3 section rolls past viewport
            if (Math.abs(position) >= track.scrollWidth / 3) {
                position = 0;
            }
            track.style.transform = `translateX(${position}px)`;
            animation = requestAnimationFrame(animate);
        };

        animation = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(animation);
    }, [loading, companies]);

    if (loading || companies.length === 0) return null;

    // Triple arrays so the animation sequence stays continuous and seamless
    const extendedCompanies = [...companies, ...companies, ...companies];

    return (
        <section className="partnerCarousel">
            {/* Background Decorations */}
            <div className="carousel-cloud cloud-1"></div>
            <div className="carousel-cloud cloud-2"></div>

            <div className="partnerHeader">
                <span className="partnerBadge">ჩვენი მეგობრები</span>
                <h2 className="partnerCarousel-title">პარტნიორი კომპანიები 🤝</h2>
            </div>

            <div className="partnerCarousel-container">
                <div className="partnerCarousel-track" ref={trackRef}>
                    {extendedCompanies.map((company, index) => (
                        <a
                            key={company.id ? `${company.id}-${index}` : index}
                            href={company.link || "https://example.com"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`partnerCarousel-item color-variant-${index % 4}`}
                        >
                            <div className="logo-wrapper">
                                <img src={company.image} alt={company.title} />
                            </div>
                            <p>{company.title}</p>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}